window.BARN_STABLE_LX_CATALOG = {
  "syncedAt": "2026-10-13",
  "source": "LingXing MCP · BARN & STABLE · Amazon US",
  "listingCount": 266,
  "sections": [
    {
      "id": "horse-sheets",
      "index": "01",
      "eyebrow": "Priority product line",
      "title": "Horse Blankets / Sheets",
      "intro": "Summer mesh, lightweight turnout and insulated winter coverage — arranged first across the full range.",
      "tone": "wine"
    },
    {
      "id": "grazing-muzzles",
      "index": "02",
      "eyebrow": "Grazing control",
      "title": "Grazing Muzzles",
      "intro": "Every current color and Small through X-Large size range.",
      "tone": "paper"
    },
    {
      "id": "fly-masks",
      "index": "03",
      "eyebrow": "Fly protection",
      "title": "Fly Masks",
      "intro": "Fine mesh and classic breathable protection for eyes and ears.",
      "tone": "ivory"
    },
    {
      "id": "girth-protection",
      "index": "04",
      "eyebrow": "Connection & protection",
      "title": "Western Girths",
      "intro": "Secure saddle connection with adjustable fit and durable hardware.",
      "tone": "paper"
    },
    {
      "id": "saddle-tack",
      "index": "05",
      "eyebrow": "Riding equipment",
      "title": "Tack & Hardware",
      "intro": "Training spurs and durable snaffle bits.",
      "tone": "ivory"
    },
    {
      "id": "stable-grooming",
      "index": "06",
      "eyebrow": "Stable organization",
      "title": "Grooming & Feeding",
      "intro": "Totes, mesh grooming bags and slow-feed hay storage.",
      "tone": "paper"
    },
    {
      "id": "travel-seasonal",
      "index": "07",
      "eyebrow": "Travel & seasonal",
      "title": "Travel Equipment",
      "intro": "Protective equipment for travel beyond the stable.",
      "tone": "ivory"
    }
  ],
  "groups": [
    {
      "family": "stableBlanket610",
      "section": "horse-sheets",
      "index": "01.1",
      "title": "Cotton-Poly Plaid Horse Stable Blanket with Horse Mask",
      "detail": "Heavyweight cotton-poly / matching fly mask",
      "parents": [
        "B0H9HXJ3F6"
      ],
      "items": [
        {
          "id": "stableBlanket610-B0H9HXJ3F6-01",
          "parent": "B0H9HXJ3F6",
          "asin": "B0H9JF87N3",
          "legacyAsins": [
            "B0H9JF87N3",
            "B0H9HTV55Q",
            "B0H9J211FJ",
            "B0H9J8K629",
            "B0H9J6PQK9"
          ],
          "slug": "cotton-poly-plaid-horse-stable-blanket-with-horse-mask-sand-navy",
          "legacySlugs": [],
          "color": "Sand-Navy",
          "productName": "Cotton-Poly Plaid Horse Stable Blanket with Horse Mask",
          "amazonTitle": "Cotton-Poly Plaid Horse Stable Blanket with Horse Mask",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/amazon-MY610-main.jpg?v=53597498791305728211793076197",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0H9JF87N3",
          "price": "$99.99",
          "priceMin": 99.99,
          "priceMax": 99.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "72 in",
            "75 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0H9JF87N3",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H9JF87N3",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H9HTV55Q",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H9HTV55Q",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H9J211FJ",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H9J211FJ",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H9J8K629",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H9J8K629",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H9J6PQK9",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H9J6PQK9",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        }
      ],
      "updatedAt": "2026-10-13",
      "amazonTitle": "Cotton-Poly Plaid Horse Stable Blanket with Horse Mask"
    },
    {
      "family": "sheet420",
      "section": "horse-sheets",
      "index": "01.2",
      "title": "420D Lightweight Turnout Sheets",
      "detail": "420D ripstop / no fill",
      "parents": [
        "B0GJ17PQJQ"
      ],
      "items": [
        {
          "id": "sheet420-B0GJ17PQJQ-03",
          "parent": "B0GJ17PQJQ",
          "asin": "B0G5XT84TL",
          "legacyAsins": [
            "B0G5XT84TL",
            "B0G5XHJ6W9",
            "B0G5XHM4F1",
            "B0G5XFPL7W",
            "B0G5XNPN8N"
          ],
          "slug": "420d-lightweight-turnout-sheets-blue-brown",
          "legacySlugs": [],
          "color": "Blue / Brown",
          "productName": "420D Lightweight Turnout Sheets",
          "amazonTitle": "420D Ripstop Lightweight Horse Turnout Sheet, No Fill, Water-Resistant & Breathable Horse Blanket for Spring and Mild Weather, with Anti-Rub Fleece Withers",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-sheet420-B0GJ17PQJQ-03-B0G5XT84TL.jpg?v=28419047024283731601793076277",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0G5XHJ6W9",
          "price": "$49.99",
          "priceMin": 49.99,
          "priceMax": 49.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "72 in",
            "75 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0G5XHJ6W9",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5XHJ6W9",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5XHM4F1",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5XHM4F1",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5XT84TL",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5XT84TL",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5XFPL7W",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5XFPL7W",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5XNPN8N",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5XNPN8N",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "sheet420-B0GJ17PQJQ-01",
          "parent": "B0GJ17PQJQ",
          "asin": "B0G5XR41XH",
          "legacyAsins": [
            "B0G5XR41XH",
            "B0G5X9GWNZ",
            "B0G5XHL2TJ",
            "B0G5XPGGB1",
            "B0G5XS43MS"
          ],
          "slug": "420d-lightweight-turnout-sheets-grey-black",
          "legacySlugs": [],
          "color": "Grey / Black",
          "productName": "420D Lightweight Turnout Sheets",
          "amazonTitle": "420D Ripstop Lightweight Horse Turnout Sheet, No Fill, Water-Resistant & Breathable Horse Blanket for Spring and Mild Weather, with Anti-Rub Fleece Withers",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-sheet420-B0GJ17PQJQ-01-B0G5XR41XH.jpg?v=146132455267317027681793076277",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0G5X9GWNZ",
          "price": "$49.99",
          "priceMin": 49.99,
          "priceMax": 49.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "72 in",
            "75 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0G5X9GWNZ",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5X9GWNZ",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5XHL2TJ",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5XHL2TJ",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5XR41XH",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5XR41XH",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5XPGGB1",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5XPGGB1",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5XS43MS",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5XS43MS",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "sheet420-B0GJ17PQJQ-02",
          "parent": "B0GJ17PQJQ",
          "asin": "B0G5X9WMCH",
          "legacyAsins": [
            "B0G5X9WMCH",
            "B0G5XLG3MH",
            "B0G5XDN22P",
            "B0G5XHP5CP",
            "B0G5XWZS7G"
          ],
          "slug": "420d-lightweight-turnout-sheets-red-black",
          "legacySlugs": [],
          "color": "Red / Black",
          "productName": "420D Lightweight Turnout Sheets",
          "amazonTitle": "420D Ripstop Lightweight Horse Turnout Sheet, No Fill, Water-Resistant & Breathable Horse Blanket for Spring and Mild Weather, with Anti-Rub Fleece Withers",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-sheet420-B0GJ17PQJQ-02-B0G5X9WMCH.jpg?v=136688082703231390121793076277",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0G5XLG3MH",
          "price": "$49.99",
          "priceMin": 49.99,
          "priceMax": 49.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "72 in",
            "75 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0G5XLG3MH",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5XLG3MH",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5X9WMCH",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5X9WMCH",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5XDN22P",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5XDN22P",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5XHP5CP",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5XHP5CP",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5XWZS7G",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5XWZS7G",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "sheet420-B0GJ17PQJQ-04",
          "parent": "B0GJ17PQJQ",
          "asin": "B0GCK5YTBX",
          "legacyAsins": [
            "B0GCK5YTBX",
            "B0GCJSK5DG",
            "B0GCJRWW1J",
            "B0GCJSVQMG",
            "B0GCJZTQ1N"
          ],
          "slug": "420d-lightweight-turnout-sheets-mustard-brown",
          "legacySlugs": [],
          "color": "Mustard / Brown",
          "productName": "420D Lightweight Turnout Sheets",
          "amazonTitle": "420D Ripstop Lightweight Horse Turnout Sheet, No Fill, Water-Resistant & Breathable Horse Blanket for Spring and Mild Weather, with Anti-Rub Fleece Withers",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-sheet420-B0GJ17PQJQ-04-B0GCK5YTBX.jpg?v=176052001581584003341793076278",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0GCJSK5DG",
          "price": "$49.99",
          "priceMin": 49.99,
          "priceMax": 49.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "72 in",
            "75 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0GCJSK5DG",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GCJSK5DG",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GCJRWW1J",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GCJRWW1J",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GCK5YTBX",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GCK5YTBX",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GCJSVQMG",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GCJSVQMG",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GCJZTQ1N",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GCJZTQ1N",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        }
      ],
      "updatedAt": "2026-10-13",
      "amazonTitle": "420D Ripstop Lightweight Horse Turnout Sheet, No Fill, Water-Resistant & Breathable Horse Blanket for Spring and Mild Weather, with Anti-Rub Fleece Withers"
    },
    {
      "family": "sheet600",
      "section": "horse-sheets",
      "index": "01.3",
      "title": "600D Lightweight Turnout Sheets",
      "detail": "600D ripstop / no fill",
      "parents": [
        "B0GHZYFFK6"
      ],
      "items": [
        {
          "id": "sheet600-B0GHZYFFK6-05",
          "parent": "B0GHZYFFK6",
          "asin": "B0G5KD1K7Z",
          "legacyAsins": [
            "B0G5KD1K7Z",
            "B0G5K2HPW9",
            "B0G5K55S3B",
            "B0G5KBP7V2",
            "B0G5KKRSL5"
          ],
          "slug": "600d-lightweight-turnout-sheets-crimson-red-black",
          "legacySlugs": [],
          "color": "Crimson Red / Black",
          "productName": "600D Lightweight Turnout Sheets",
          "amazonTitle": "600D Ripstop Lightweight Horse Turnout Sheet No Fill,Water-Resistant & Breathable Horse Blanket for Spring and Mild Weather, with Anti-Rub Fleece Withers",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-sheet600-B0GHZYFFK6-05-B0G5KD1K7Z.jpg?v=6513956979470626921793076279",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0G5K2HPW9",
          "price": "$55.99",
          "priceMin": 55.99,
          "priceMax": 55.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "72 in",
            "75 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0G5K2HPW9",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5K2HPW9",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5KD1K7Z",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5KD1K7Z",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5K55S3B",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5K55S3B",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5KBP7V2",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5KBP7V2",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5KKRSL5",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5KKRSL5",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "sheet600-B0GHZYFFK6-halloween",
          "parent": "B0GHZYFFK6",
          "asin": "B0H9HMRC8J",
          "legacyAsins": [
            "B0H9HMRC8J",
            "B0H9J1FG4L",
            "B0H9HXHM1B",
            "B0H9J194T5",
            "B0H9HV4QFL"
          ],
          "slug": "600d-ripstop-lightweight-horse-turnout-sheet-halloween",
          "legacySlugs": [],
          "color": "Halloween",
          "productName": "600D Ripstop Lightweight Horse Turnout Sheet",
          "amazonTitle": "600D Ripstop Lightweight Horse Turnout Sheet No Fill,Water-Resistant & Breathable Horse Blanket for Spring and Mild Weather, with Anti-Rub Fleece Withers (Halloween, 69 in)",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/amazon-halloween-turnout-sheet.jpg?v=67917358320827312471793076196",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0H9HMRC8J",
          "price": "$55.99",
          "priceMin": 55.99,
          "priceMax": 55.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "72 in",
            "75 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0H9HMRC8J",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H9HMRC8J",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H9J1FG4L",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H9J1FG4L",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H9HXHM1B",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H9HXHM1B",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H9J194T5",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H9J194T5",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H9HV4QFL",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H9HV4QFL",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": true
        },
        {
          "id": "sheet600-B0GHZYFFK6-02",
          "parent": "B0GHZYFFK6",
          "asin": "B0G5KMP553",
          "legacyAsins": [
            "B0G5KMP553",
            "B0G5K2J9RY",
            "B0G5K6LDCM",
            "B0G5L2H1Y4",
            "B0G5K7D62S"
          ],
          "slug": "600d-lightweight-turnout-sheets-royal-purple-black",
          "legacySlugs": [],
          "color": "Royal Purple / Black",
          "productName": "600D Lightweight Turnout Sheets",
          "amazonTitle": "600D Ripstop Lightweight Horse Turnout Sheet No Fill,Water-Resistant & Breathable Horse Blanket for Spring and Mild Weather, with Anti-Rub Fleece Withers",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-sheet600-B0GHZYFFK6-02-B0G5KMP553.jpg?v=33823560012901287571793076278",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0G5KMP553",
          "price": "$55.99",
          "priceMin": 55.99,
          "priceMax": 55.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "72 in",
            "75 in",
            "69 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0G5KMP553",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5KMP553",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5K2J9RY",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5K2J9RY",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5K6LDCM",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5K6LDCM",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5L2H1Y4",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5L2H1Y4",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5K7D62S",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5K7D62S",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "sheet600-B0GHZYFFK6-01",
          "parent": "B0GHZYFFK6",
          "asin": "B0GWD63948",
          "legacyAsins": [
            "B0GWD63948",
            "B0GWD3SMSS",
            "B0GWD9DWP2",
            "B0GWDCNDX7",
            "B0GWD352JY"
          ],
          "slug": "600d-lightweight-turnout-sheets-navy-with-floral-trim",
          "legacySlugs": [],
          "color": "Navy with Floral Trim",
          "productName": "600D Lightweight Turnout Sheets",
          "amazonTitle": "600D Ripstop Lightweight Horse Turnout Sheet No Fill,Water-Resistant & Breathable Horse Blanket for Spring and Mild Weather, with Anti-Rub Fleece Withers (Navy with Floral Trim, 75 in)",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-sheet600-B0GHZYFFK6-01-B0GWD63948.jpg?v=79833194952054162411793076278",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0GWD3SMSS",
          "price": "$55.99",
          "priceMin": 55.99,
          "priceMax": 55.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "72 in",
            "75 in",
            "69 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0GWD3SMSS",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GWD3SMSS",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GWD63948",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GWD63948",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GWD9DWP2",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GWD9DWP2",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GWDCNDX7",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GWDCNDX7",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GWD352JY",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GWD352JY",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "sheet600-B0GHZYFFK6-07",
          "parent": "B0GHZYFFK6",
          "asin": "B0G5K8NXM6",
          "legacyAsins": [
            "B0G5K8NXM6",
            "B0G5K95NVD",
            "B0G5KBV31H",
            "B0G5KM2ZSR",
            "B0G5K9L7BG"
          ],
          "slug": "600d-lightweight-turnout-sheets-chestnut-brown",
          "legacySlugs": [],
          "color": "Chestnut Brown",
          "productName": "600D Lightweight Turnout Sheets",
          "amazonTitle": "600D Ripstop Lightweight Horse Turnout Sheet No Fill,Water-Resistant & Breathable Horse Blanket for Spring and Mild Weather, with Anti-Rub Fleece Withers",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-sheet600-B0GHZYFFK6-07-B0G5K8NXM6.jpg?v=7876022087776931581793076280",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0G5K8NXM6",
          "price": "$55.99",
          "priceMin": 55.99,
          "priceMax": 55.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "72 in",
            "69 in",
            "75 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0G5K8NXM6",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5K8NXM6",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5K95NVD",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5K95NVD",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5KBV31H",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5KBV31H",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5KM2ZSR",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5KM2ZSR",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5K9L7BG",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5K9L7BG",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "sheet600-B0GHZYFFK6-03",
          "parent": "B0GHZYFFK6",
          "asin": "B0G5K7FP4C",
          "legacyAsins": [
            "B0G5K7FP4C",
            "B0G5KKKNWB",
            "B0G5KGYX2K",
            "B0G5KYBVTY",
            "B0G5K584V6"
          ],
          "slug": "600d-lightweight-turnout-sheets-midnight-navy",
          "legacySlugs": [],
          "color": "Midnight Navy",
          "productName": "600D Lightweight Turnout Sheets",
          "amazonTitle": "600D Ripstop Lightweight Horse Turnout Sheet No Fill,Water-Resistant & Breathable Horse Blanket for Spring and Mild Weather, with Anti-Rub Fleece Withers",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-sheet600-B0GHZYFFK6-03-B0G5K7FP4C.jpg?v=105085205112788354471793076279",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0G5K7FP4C",
          "price": "$55.99",
          "priceMin": 55.99,
          "priceMax": 55.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "72 in",
            "75 in",
            "69 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0G5K7FP4C",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5K7FP4C",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5KKKNWB",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5KKKNWB",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5KGYX2K",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5KGYX2K",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5KYBVTY",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0G5KYBVTY",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5K584V6",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5K584V6",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "sheet600-B0GHZYFFK6-04",
          "parent": "B0GHZYFFK6",
          "asin": "B0G5KS29TK",
          "legacyAsins": [
            "B0G5K3ZCQ5",
            "B0G5KS29TK",
            "B0G5KN8KHF",
            "B0G5JXXRMV",
            "B0G5K6J3D1"
          ],
          "slug": "600d-lightweight-turnout-sheets-royal-blue-black",
          "legacySlugs": [],
          "color": "Royal Blue / Black",
          "productName": "600D Lightweight Turnout Sheets",
          "amazonTitle": "600D Ripstop Lightweight Horse Turnout Sheet No Fill,Water-Resistant & Breathable Horse Blanket for Spring and Mild Weather, with Anti-Rub Fleece Withers",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-sheet600-B0GHZYFFK6-04-B0G5K3ZCQ5.jpg?v=32339027035772981861793076279",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0G5KS29TK",
          "price": "$55.99",
          "priceMin": 55.99,
          "priceMax": 55.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "72 in",
            "69 in",
            "75 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0G5KS29TK",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5KS29TK",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5KN8KHF",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5KN8KHF",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5K3ZCQ5",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5K3ZCQ5",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5JXXRMV",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5JXXRMV",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5K6J3D1",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5K6J3D1",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "sheet600-B0GHZYFFK6-06",
          "parent": "B0GHZYFFK6",
          "asin": "B0G5K779JG",
          "legacyAsins": [
            "B0G5KWP4DP",
            "B0G5K779JG",
            "B0G5KM96R8",
            "B0G5KKLMF1",
            "B0G5JYKQ87"
          ],
          "slug": "600d-lightweight-turnout-sheets-brown-embossed-leather-brown",
          "legacySlugs": [],
          "color": "Brown Embossed Leather / Brown",
          "productName": "600D Lightweight Turnout Sheets",
          "amazonTitle": "600D Ripstop Lightweight Horse Turnout Sheet No Fill,Water-Resistant & Breathable Horse Blanket for Spring and Mild Weather, with Anti-Rub Fleece Withers",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-sheet600-B0GHZYFFK6-06-B0G5KWP4DP.jpg?v=173546366635304112661793076280",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0G5K779JG",
          "price": null,
          "priceMin": null,
          "priceMax": null,
          "priceNote": "Check price on Amazon",
          "availability": "unavailable",
          "status": "Not currently listed for sale",
          "updatedAt": "2026-10-13",
          "archived": true,
          "sizes": [
            "69 in",
            "72 in",
            "75 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0G5K779JG",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5K779JG",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5KWP4DP",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5KWP4DP",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5KM96R8",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5KM96R8",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5KKLMF1",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5KKLMF1",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G5JYKQ87",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G5JYKQ87",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        }
      ],
      "updatedAt": "2026-10-13",
      "amazonTitle": "600D Ripstop Lightweight Horse Turnout Sheet No Fill,Water-Resistant & Breathable Horse Blanket for Spring and Mild Weather, with Anti-Rub Fleece Withers"
    },
    {
      "family": "mesh",
      "section": "horse-sheets",
      "index": "01.4",
      "title": "Summer Mesh Fly Sheets",
      "detail": "Breathable mesh / UV coverage",
      "parents": [
        "B0GHSKJ181",
        "B0HC5VF26W",
        "B0HMP9GCQ2",
        "B0GZF5BNJP",
        "B0GZF16XV2",
        "B0HMP65652",
        "B0GHP4W2P9"
      ],
      "items": [
        {
          "id": "mesh-B0GHSKJ181-03",
          "parent": "B0GZF5BNJP",
          "asin": "B0GZF5BNJP",
          "legacyAsins": [
            "B0GZF5BNJP",
            "B0GZF4K152",
            "B0GZF52WHS",
            "B0GZF8F6PV",
            "B0GZDRZCD2"
          ],
          "slug": "summer-mesh-fly-sheets-evergreen",
          "legacySlugs": [],
          "color": "Evergreen",
          "productName": "Summer Mesh Fly Sheets",
          "amazonTitle": "Breathable and UV Protective Tear-Resistant Mesh Horse Fly Sheet Comfy Equine Summer Sheet with Removable Web Leg Straps",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-mesh-B0GHSKJ181-03-B0GZF5BNJP.jpg?v=38679228074843654971793076271",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0GZF5BNJP",
          "price": "$45.99",
          "priceMin": 45.99,
          "priceMax": 45.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Option 1 — confirm size on Amazon",
            "Option 2 — confirm size on Amazon",
            "69 in",
            "72 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0GZF5BNJP",
              "size": "Option 1 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GZF5BNJP",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GZF4K152",
              "size": "Option 2 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GZF4K152",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GZF52WHS",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GZF52WHS",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GZF8F6PV",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GZF8F6PV",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GZDRZCD2",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GZDRZCD2",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "mesh-B0GHSKJ181-04",
          "parent": "B0HC5VF26W",
          "asin": "B0GHPGJWFP",
          "legacyAsins": [
            "B0GHPGJWFP",
            "B0GHP29YFX",
            "B0GHP49V3M",
            "B0GHPL9541",
            "B0GHPS1FKN"
          ],
          "slug": "summer-mesh-fly-sheets-silver-gold",
          "legacySlugs": [],
          "color": "Silver Gold",
          "productName": "Summer Mesh Fly Sheets",
          "amazonTitle": "Breathable and UV Protective Tear-Resistant Mesh Horse Fly Sheet Comfy Equine Summer Sheet with Removable Web Leg Straps",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-mesh-B0GHSKJ181-04-B0GHPGJWFP.jpg?v=54115922270838958951793076271",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0GHP29YFX",
          "price": "$49.99",
          "priceMin": 49.99,
          "priceMax": 49.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "75 in",
            "78 in",
            "69 in",
            "72 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0GHP29YFX",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHP29YFX",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHPGJWFP",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHPGJWFP",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHP49V3M",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHP49V3M",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHPL9541",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 55.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHPL9541",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHPS1FKN",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0GHPS1FKN",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "mesh-B0GHSKJ181-06",
          "parent": "B0HMP9GCQ2",
          "asin": "B0GZF74X8K",
          "legacyAsins": [
            "B0GZF74X8K",
            "B0GZF4PLSS",
            "B0GZF4J3W9",
            "B0GZDT1HHQ",
            "B0GZFB8D24"
          ],
          "slug": "summer-mesh-fly-sheets-golden-glow",
          "legacySlugs": [],
          "color": "Golden Glow",
          "productName": "Summer Mesh Fly Sheets",
          "amazonTitle": "Breathable and UV Protective Tear-Resistant Mesh Horse Fly Sheet Comfy Equine Summer Sheet with Removable Web Leg Straps",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-mesh-B0GHSKJ181-06-B0GZF74X8K.jpg?v=161396801904915425671793076272",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0GZF4PLSS",
          "price": "$45.99",
          "priceMin": 45.99,
          "priceMax": 45.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Option 1 — confirm size on Amazon",
            "69 in",
            "72 in",
            "75 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0GZF4PLSS",
              "size": "Option 1 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GZF4PLSS",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GZF4J3W9",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GZF4J3W9",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GZDT1HHQ",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GZDT1HHQ",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GZF74X8K",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GZF74X8K",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GZFB8D24",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GZFB8D24",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "mesh-B0GHSKJ181-07",
          "parent": "B0GZF16XV2",
          "asin": "B0GZF16XV2",
          "legacyAsins": [
            "B0GZF16XV2",
            "B0GZF412QZ",
            "B0GZFDZRPP",
            "B0GZDZ282N",
            "B0GZDSYFLF"
          ],
          "slug": "summer-mesh-fly-sheets-dark-purple",
          "legacySlugs": [],
          "color": "Dark Purple",
          "productName": "Summer Mesh Fly Sheets",
          "amazonTitle": "Breathable and UV Protective Tear-Resistant Mesh Horse Fly Sheet Comfy Equine Summer Sheet with Removable Web Leg Straps",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-mesh-B0GHSKJ181-07-B0GZF16XV2.jpg?v=139190862248658357661793076272",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0GZF412QZ",
          "price": "$45.99",
          "priceMin": 45.99,
          "priceMax": 45.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Option 1 — confirm size on Amazon",
            "Option 2 — confirm size on Amazon",
            "78 in",
            "81 in",
            "69 in"
          ],
          "variants": [
            {
              "asin": "B0GZF412QZ",
              "size": "Option 1 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GZF412QZ",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GZF16XV2",
              "size": "Option 2 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GZF16XV2",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GZFDZRPP",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GZFDZRPP",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GZDZ282N",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GZDZ282N",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GZDSYFLF",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GZDSYFLF",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "mesh-B0GHSKJ181-08",
          "parent": "B0HMP9GCQ2",
          "asin": "B0GHPS1FL7",
          "legacyAsins": [
            "B0GHPS1FL7",
            "B0GHPBQBNT",
            "B0GHPN3QH6",
            "B0GHPBXVT5",
            "B0GHPGX75G"
          ],
          "slug": "summer-mesh-fly-sheets-white-curvy-fit",
          "legacySlugs": [],
          "color": "White - Curvy Fit",
          "productName": "Summer Mesh Fly Sheets",
          "amazonTitle": "Breathable and UV Protective Tear-Resistant Mesh Horse Fly Sheet Comfy Equine Summer Sheet with Removable Web Leg Straps",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-mesh-B0GHSKJ181-08-B0GHPS1FL7.jpg?v=108046430171221583991793076272",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0GHPBQBNT",
          "price": "$45.99",
          "priceMin": 45.99,
          "priceMax": 45.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "72 in",
            "75 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0GHPBQBNT",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHPBQBNT",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHPN3QH6",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHPN3QH6",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHPS1FL7",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHPS1FL7",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHPBXVT5",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHPBXVT5",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHPGX75G",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHPGX75G",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "mesh-B0GHSKJ181-02",
          "parent": "B0HC5VF26W",
          "asin": "B0GHPLBJX3",
          "legacyAsins": [
            "B0GHPLBJX3",
            "B0GHPJGDZL",
            "B0GHP5KTYP",
            "B0GHP5H1WQ",
            "B0GHP5L7QZ"
          ],
          "slug": "summer-mesh-fly-sheets-gold-silver",
          "legacySlugs": [],
          "color": "Gold Silver",
          "productName": "Summer Mesh Fly Sheets",
          "amazonTitle": "Breathable and UV Protective Tear-Resistant Mesh Horse Fly Sheet Comfy Equine Summer Sheet with Removable Web Leg Straps",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-mesh-B0GHSKJ181-02-B0GHPLBJX3.jpg?v=113734010916403368561793076270",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0GHPJGDZL",
          "price": "$49.99",
          "priceMin": 49.99,
          "priceMax": 49.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "75 in",
            "78 in",
            "69 in",
            "72 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0GHPJGDZL",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHPJGDZL",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHPLBJX3",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHPLBJX3",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHP5KTYP",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHP5KTYP",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHP5H1WQ",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHP5H1WQ",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHP5L7QZ",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0GHP5L7QZ",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "mesh-B0GHSKJ181-01",
          "parent": "B0HMP65652",
          "asin": "B0GHP27W19",
          "legacyAsins": [
            "B0GHP27W19",
            "B0GHP5MBML",
            "B0GHP9KMS4",
            "B0GHPSRCVC",
            "B0GHPBYRMQ"
          ],
          "slug": "summer-mesh-fly-sheets-white-loose-fit",
          "legacySlugs": [],
          "color": "White - Loose Fit",
          "productName": "Summer Mesh Fly Sheets",
          "amazonTitle": "Breathable and UV Protective Tear-Resistant Mesh Horse Fly Sheet Comfy Equine Summer Sheet with Removable Web Leg Straps",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-mesh-B0GHSKJ181-01-B0GHP27W19.jpg?v=9689980710944890791793076270",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0GHP5MBML",
          "price": "$45.99",
          "priceMin": 45.99,
          "priceMax": 45.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Option 1 — confirm size on Amazon",
            "Option 2 — confirm size on Amazon",
            "Option 3 — confirm size on Amazon",
            "75 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0GHP5MBML",
              "size": "Option 1 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHP5MBML",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHP9KMS4",
              "size": "Option 2 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHP9KMS4",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHPSRCVC",
              "size": "Option 3 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHPSRCVC",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHP27W19",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHP27W19",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHPBYRMQ",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 45.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHPBYRMQ",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "mesh-B0GHSKJ181-05",
          "parent": "B0GHP29VH8",
          "asin": "B0GHP29VH8",
          "legacyAsins": [
            "B0GHP4W2P9",
            "B0GHP29VH8",
            "B0GHPBNBWH"
          ],
          "slug": "summer-mesh-fly-sheets-sand",
          "legacySlugs": [],
          "color": "Sand",
          "productName": "Summer Mesh Fly Sheets",
          "amazonTitle": "Breathable and UV Protective Tear-Resistant Mesh Horse Fly Sheet Comfy Equine Summer Sheet with Removable Web Leg Straps",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-mesh-B0GHSKJ181-05-B0GHP4W2P9.jpg?v=63245227553655792321793076271",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0GHP29VH8",
          "price": "$49.99",
          "priceMin": 49.99,
          "priceMax": 49.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Option 1 — confirm size on Amazon",
            "Option 2 — confirm size on Amazon",
            "Option 3 — confirm size on Amazon"
          ],
          "variants": [
            {
              "asin": "B0GHP29VH8",
              "size": "Option 1 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHP29VH8",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHPBNBWH",
              "size": "Option 2 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 53.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHPBNBWH",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHP4W2P9",
              "size": "Option 3 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHP4W2P9",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        }
      ],
      "updatedAt": "2026-10-13",
      "amazonTitle": "Breathable and UV Protective Tear-Resistant Mesh Horse Fly Sheet Comfy Equine Summer Sheet with Removable Web Leg Straps"
    },
    {
      "family": "winter600",
      "section": "horse-sheets",
      "index": "01.5",
      "title": "600D Winter Blankets",
      "detail": "Waterproof / breathable / 200g fill",
      "parents": [
        "B0G16HGNZ9"
      ],
      "items": [
        {
          "id": "winter600-B0G16HGNZ9-02",
          "parent": "B0G16HGNZ9",
          "asin": "B0FMYVHMPT",
          "legacyAsins": [
            "B0FMYVHMPT",
            "B0FMYSM2X2",
            "B0FMYSRX73",
            "B0FMYSBGQC",
            "B0FMYTC2QZ",
            "B0HJNNDGDD",
            "B0HJNVHBK9",
            "B0HJNVW6G2"
          ],
          "slug": "600d-winter-blankets-navy-gray",
          "legacySlugs": [],
          "color": "Navy-gray",
          "productName": "600D Winter Blankets",
          "amazonTitle": "600Denier 3000mm/3000mvp Super Waterproof & Breathable Horse Blankets for Winter with 200g Fill",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-winter600-B0G16HGNZ9-02-B0FMYVHMPT.jpg?v=132112050753504864611793076282",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0FMYVHMPT",
          "price": "$84.99",
          "priceMin": 84.99,
          "priceMax": 84.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "72 in",
            "75 in",
            "78 in",
            "81 in",
            "60 in",
            "63 in",
            "66 in"
          ],
          "variants": [
            {
              "asin": "B0FMYVHMPT",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 84.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYVHMPT",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FMYSM2X2",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 84.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYSM2X2",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FMYSRX73",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 84.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYSRX73",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FMYSBGQC",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 84.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYSBGQC",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FMYTC2QZ",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 84.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYTC2QZ",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HJNNDGDD",
              "size": "60 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HJNNDGDD",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HJNVHBK9",
              "size": "63 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HJNVHBK9",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HJNVW6G2",
              "size": "66 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HJNVW6G2",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "winter600-B0G16HGNZ9-04",
          "parent": "B0G16HGNZ9",
          "asin": "B0FMYTS69F",
          "legacyAsins": [
            "B0FMYTS69F",
            "B0FMYWFFTP",
            "B0FMYSR9DY",
            "B0FMYX1QC3",
            "B0FMYVQH2R",
            "B0HJNQDCBZ",
            "B0HJNZCCPN",
            "B0HJNY2237",
            "B0DHDNY9LB",
            "B0DHF459VC",
            "B0DHF6XWCM",
            "B0DHF3C5P8",
            "B0DHF4ZCPQ"
          ],
          "slug": "600d-winter-blankets-navy-red",
          "legacySlugs": [],
          "color": "Navy-red",
          "productName": "600D Winter Blankets",
          "amazonTitle": "600Denier 3000mm/3000mvp Super Waterproof & Breathable Horse Blankets for Winter with 200g Fill",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-winter600-B0G16HGNZ9-04-B0FMYTS69F.jpg?v=75706485351716073541793076283",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0FMYWFFTP",
          "price": "$84.99",
          "priceMin": 84.99,
          "priceMax": 84.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "72 in",
            "75 in",
            "78 in",
            "81 in",
            "60 in",
            "63 in",
            "66 in"
          ],
          "variants": [
            {
              "asin": "B0FMYWFFTP",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 84.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYWFFTP",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FMYTS69F",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 84.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYTS69F",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FMYSR9DY",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 84.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYSR9DY",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FMYX1QC3",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 84.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYX1QC3",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FMYVQH2R",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 84.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYVQH2R",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HJNQDCBZ",
              "size": "60 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HJNQDCBZ",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HJNZCCPN",
              "size": "63 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HJNZCCPN",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HJNY2237",
              "size": "66 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HJNY2237",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0DHDNY9LB",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0DHDNY9LB",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0DHF459VC",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0DHF459VC",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0DHF6XWCM",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0DHF6XWCM",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0DHF3C5P8",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0DHF3C5P8",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0DHF4ZCPQ",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0DHF4ZCPQ",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "winter600-B0G16HGNZ9-01",
          "parent": "B0G16HGNZ9",
          "asin": "B0FMYVBMYT",
          "legacyAsins": [
            "B0FMYVBMYT",
            "B0FMYWZDNC",
            "B0FMYSHM4B",
            "B0FMYS3S7S",
            "B0FMYVN881"
          ],
          "slug": "600d-winter-blankets-sea-pink-plume",
          "legacySlugs": [],
          "color": "Sea Pink/Plume",
          "productName": "600D Winter Blankets",
          "amazonTitle": "600Denier 3000mm/3000mvp Super Waterproof & Breathable Horse Blankets for Winter with 200g Fill",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-winter600-B0G16HGNZ9-01-B0FMYVBMYT.jpg?v=67614737620072594521793076282",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0FMYWZDNC",
          "price": "$88.99",
          "priceMin": 88.99,
          "priceMax": 88.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "75 in",
            "78 in",
            "72 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0FMYWZDNC",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYWZDNC",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FMYSHM4B",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYSHM4B",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FMYVBMYT",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYVBMYT",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FMYS3S7S",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0FMYS3S7S",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FMYVN881",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0FMYVN881",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "winter600-600d-winter-blankets-fern-green-navy",
          "parent": "B0G16HGNZ9",
          "asin": "B0H5BDR33C",
          "legacyAsins": [
            "B0H5BDR33C",
            "B0H5B8QLN2",
            "B0H5BH54C6",
            "B0H5BJJH6N",
            "B0H5BTXDZC"
          ],
          "slug": "600d-winter-blankets-fern-green-navy",
          "legacySlugs": [],
          "color": "Fern Green/Navy",
          "productName": "600D Winter Blankets",
          "amazonTitle": "600Denier 3000mm/3000mvp Super Waterproof & Breathable Horse Blankets for Winter with 200g Fill (Fern Green/Navy, 69 Inch)",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-B0H5BDR33C.webp?v=97333004860647817651793076261",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0H5BDR33C",
          "price": "$88.99",
          "priceMin": 88.99,
          "priceMax": 88.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "72 in",
            "75 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0H5BDR33C",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H5BDR33C",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H5B8QLN2",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H5B8QLN2",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H5BH54C6",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H5BH54C6",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H5BJJH6N",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H5BJJH6N",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H5BTXDZC",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H5BTXDZC",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "winter600-600d-winter-blankets-vibrant-orange-navy",
          "parent": "B0G16HGNZ9",
          "asin": "B0H5BGGK9B",
          "legacyAsins": [
            "B0H5BGGK9B",
            "B0H5BGSCZ7",
            "B0H5BNP53Q",
            "B0H5BM5QZD",
            "B0H5BNLWHG"
          ],
          "slug": "600d-winter-blankets-vibrant-orange-navy",
          "legacySlugs": [],
          "color": "Vibrant Orange/Navy",
          "productName": "600D Winter Blankets",
          "amazonTitle": "600Denier 3000mm/3000mvp Super Waterproof & Breathable Horse Blankets for Winter with 200g Fill (Vibrant Orange/Navy, 69 Inch)",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-B0H5BGGK9B.webp?v=18451126879539935731793076262",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0H5BGGK9B",
          "price": "$88.99",
          "priceMin": 88.99,
          "priceMax": 88.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "72 in",
            "75 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0H5BGGK9B",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H5BGGK9B",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H5BGSCZ7",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H5BGSCZ7",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H5BNP53Q",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H5BNP53Q",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H5BM5QZD",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H5BM5QZD",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H5BNLWHG",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H5BNLWHG",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "winter600-B0G16HGNZ9-07",
          "parent": "B0G16HGNZ9",
          "asin": "B0H5BPDPDV",
          "legacyAsins": [
            "B0H5BPDPDV",
            "B0H5BC3M14",
            "B0H5BHS6RK",
            "B0H5BD45HZ",
            "B0H5BH7XGB"
          ],
          "slug": "600d-winter-blankets-classic-red-navy",
          "legacySlugs": [],
          "color": "Classic Red/Navy",
          "productName": "600D Winter Blankets",
          "amazonTitle": "600Denier 3000mm/3000mvp Super Waterproof & Breathable Horse Blankets for Winter with 200g Fill (Classic Red/Navy, 69 Inch)",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-winter600-B0G16HGNZ9-07-B0H5BPDPDV.jpg?v=33829245657504362291793076284",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0H5BPDPDV",
          "price": "$88.99",
          "priceMin": 88.99,
          "priceMax": 88.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "72 in",
            "75 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0H5BPDPDV",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H5BPDPDV",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H5BC3M14",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H5BC3M14",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H5BHS6RK",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H5BHS6RK",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H5BD45HZ",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H5BD45HZ",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H5BH7XGB",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H5BH7XGB",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "winter600-B0G16HGNZ9-06",
          "parent": "B0G16HGNZ9",
          "asin": "B0FMYT1522",
          "legacyAsins": [
            "B0FMYT1522",
            "B0FMYTY6CS",
            "B0FMYRH61S",
            "B0FMYVH358",
            "B0FMYT3CNN"
          ],
          "slug": "600d-winter-blankets-ashley-blue-navy",
          "legacySlugs": [],
          "color": "Ashley Blue/Navy",
          "productName": "600D Winter Blankets",
          "amazonTitle": "600Denier 3000mm/3000mvp Super Waterproof & Breathable Horse Blankets for Winter with 200g Fill",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-winter600-B0G16HGNZ9-06-B0FMYT1522.jpg?v=50050708993494142051793076284",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0FMYTY6CS",
          "price": "$88.99",
          "priceMin": 88.99,
          "priceMax": 88.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "72 in",
            "75 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0FMYTY6CS",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYTY6CS",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FMYRH61S",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYRH61S",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FMYT1522",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYT1522",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FMYVH358",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYVH358",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FMYT3CNN",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 65.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYT3CNN",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "winter600-B0G16HGNZ9-03",
          "parent": "B0G16HGNZ9",
          "asin": "B0FMYVLQM4",
          "legacyAsins": [
            "B0FMYVLQM4",
            "B0FMYSX9ZY",
            "B0FMYWNTLW",
            "B0FMYTFX14",
            "B0FMYV2X18"
          ],
          "slug": "600d-winter-blankets-ancora-red-senior-grey",
          "legacySlugs": [],
          "color": "Ancora Red/Senior Grey",
          "productName": "600D Winter Blankets",
          "amazonTitle": "600Denier 3000mm/3000mvp Super Waterproof & Breathable Horse Blankets for Winter with 200g Fill",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-winter600-B0G16HGNZ9-03-B0FMYVLQM4.jpg?v=33813371227956408201793076282",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0FMYSX9ZY",
          "price": "$88.99",
          "priceMin": 88.99,
          "priceMax": 88.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "72 in",
            "75 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0FMYSX9ZY",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYSX9ZY",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FMYVLQM4",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYVLQM4",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FMYWNTLW",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYWNTLW",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FMYTFX14",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FMYTFX14",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FMYV2X18",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0FMYV2X18",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "winter600-B0G16HGNZ9-05",
          "parent": "B0G16HGNZ9",
          "asin": "B0G4M9HR9H",
          "legacyAsins": [
            "B0G4M9HR9H",
            "B0G4MB33BX",
            "B0G4MDNZ9F",
            "B0G4MCDC1P",
            "B0G4M9BG6L"
          ],
          "slug": "600d-winter-blankets-pink-blue",
          "legacySlugs": [],
          "color": "Pink/Blue",
          "productName": "600D Winter Blankets",
          "amazonTitle": "600Denier 3000mm/3000mvp Super Waterproof & Breathable Horse Blankets for Winter with 200g Fill (Pink/Blue, 78 Inch)",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-winter600-B0G16HGNZ9-05-B0G4M9HR9H.jpg?v=60164379724191581793076283",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0G4M9HR9H",
          "price": "$88.99",
          "priceMin": 88.99,
          "priceMax": 88.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "78 in",
            "69 in",
            "72 in",
            "75 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0G4M9HR9H",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 88.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0G4M9HR9H",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G4MB33BX",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0G4MB33BX",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G4MDNZ9F",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0G4MDNZ9F",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G4MCDC1P",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0G4MCDC1P",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0G4M9BG6L",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0G4M9BG6L",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "winter600-B0G16HGNZ9-08",
          "parent": "B0G16HGNZ9",
          "asin": "B0DHF4LWW1",
          "legacyAsins": [
            "B0DHF7RWY3",
            "B0DHF4LWW1",
            "B0DHDZKM7R",
            "B0DHFCPFM8",
            "B0DHDY3KXP"
          ],
          "slug": "600d-winter-blankets-red-navy",
          "legacySlugs": [],
          "color": "Red/Navy",
          "productName": "600D Winter Blankets",
          "amazonTitle": "600Denier 3000mm/3000mvp Super Waterproof & Breathable Horse Blankets for Winter with 200g Fill",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-winter600-B0G16HGNZ9-10-B0DHF7RWY3.jpg?v=121368103689991153731793076285",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0DHF4LWW1",
          "price": null,
          "priceMin": null,
          "priceMax": null,
          "priceNote": "Check price on Amazon",
          "availability": "unavailable",
          "status": "Not currently listed for sale",
          "updatedAt": "2026-10-13",
          "archived": true,
          "sizes": [
            "69 in",
            "72 in",
            "75 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0DHF4LWW1",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0DHF4LWW1",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0DHDZKM7R",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0DHDZKM7R",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0DHF7RWY3",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 79.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0DHF7RWY3",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0DHFCPFM8",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0DHFCPFM8",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0DHDY3KXP",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0DHDY3KXP",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        }
      ],
      "updatedAt": "2026-10-13",
      "gallery": [
        "https://m.media-amazon.com/images/I/71bV5bTLv8L._AC_SL1500_.jpg",
        "https://m.media-amazon.com/images/I/71Qnr48ZzUL._AC_SL1500_.jpg",
        "https://m.media-amazon.com/images/I/91cGkz5Z-3L._AC_SL1500_.jpg",
        "https://m.media-amazon.com/images/I/81maAoKekIL._AC_SL1500_.jpg",
        "https://m.media-amazon.com/images/I/912Zq5p8-DL._AC_SL1500_.jpg",
        "https://m.media-amazon.com/images/I/A1FkwvJNgLL._AC_SL1500_.jpg"
      ],
      "aplus": [],
      "amazonTitle": "600Denier 3000mm/3000mvp Super Waterproof & Breathable Horse Blankets for Winter with 200g Fill"
    },
    {
      "family": "winter1680",
      "section": "horse-sheets",
      "index": "01.6",
      "title": "1680D Winter Blanket",
      "detail": "Heavy-duty / 250g fill",
      "parents": [
        "B0FXFD6WM3"
      ],
      "items": [
        {
          "id": "winter1680-B0FXFD6WM3-01",
          "parent": "B0FXFD6WM3",
          "asin": "B0DJ5JF1XJ",
          "legacyAsins": [
            "B0DJ5JF1XJ",
            "B0DJ5LN4VP",
            "B0DJ5KLVDG",
            "B0DJ5K4B63",
            "B0DJ5L1WFM"
          ],
          "slug": "1680d-winter-blanket-blue-mirage-insignia-blue",
          "legacySlugs": [],
          "color": "Blue Mirage/Insignia Blue",
          "productName": "1680D Winter Blanket",
          "amazonTitle": "1680Denier 3000mm/3000mvp Super Waterproof & Breathable Horse Blankets for Winter with 250g Fill",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-winter1680-B0FXFD6WM3-01-B0DJ5JF1XJ.jpg?v=47597061799048701181793076281",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0DJ5JF1XJ",
          "price": null,
          "priceMin": null,
          "priceMax": null,
          "priceNote": "Check price on Amazon",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "75 in",
            "69 in",
            "72 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0DJ5JF1XJ",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0DJ5JF1XJ",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0DJ5LN4VP",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0DJ5LN4VP",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0DJ5KLVDG",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0DJ5KLVDG",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0DJ5K4B63",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0DJ5K4B63",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0DJ5L1WFM",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0DJ5L1WFM",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "winter1680-1680d-winter-blanket-navy-gray-blue",
          "parent": "B0FXFD6WM3",
          "asin": "B0HDL4T2SK",
          "legacyAsins": [
            "B0HDL4T2SK",
            "B0HDLFGKHD",
            "B0HDL31KTJ",
            "B0HDLGR7D6",
            "B0HDL7XJ7D"
          ],
          "slug": "1680d-winter-blanket-navy-gray-blue",
          "legacySlugs": [],
          "color": "Navy/Gray Blue",
          "productName": "1680D Winter Blanket",
          "amazonTitle": "1680Denier 3000mm/3000mvp Super Waterproof & Breathable Horse Blankets for Winter with 250g Fill (Navy/Gray Blue, 69 Inch)",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-B0HDL4T2SK.webp?v=32150000983372602531793076263",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0HDL4T2SK",
          "price": "$99.99",
          "priceMin": 99.99,
          "priceMax": 99.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "72 in",
            "75 in",
            "78 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0HDL4T2SK",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDL4T2SK",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HDLFGKHD",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDLFGKHD",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HDL31KTJ",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDL31KTJ",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HDLGR7D6",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDLGR7D6",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HDL7XJ7D",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDL7XJ7D",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "winter1680-1680d-winter-blanket-hunter-green-gray-blue",
          "parent": "B0FXFD6WM3",
          "asin": "B0HDLL6ZRS",
          "legacyAsins": [
            "B0HDLL6ZRS",
            "B0HDL4SSBG",
            "B0HDLD334D",
            "B0HDL7382P",
            "B0HDLDMZCH"
          ],
          "slug": "1680d-winter-blanket-hunter-green-gray-blue",
          "legacySlugs": [],
          "color": "Hunter Green/Gray Blue",
          "productName": "1680D Winter Blanket",
          "amazonTitle": "1680Denier 3000mm/3000mvp Super Waterproof & Breathable Horse Blankets for Winter with 250g Fill (Hunter Green/Gray Blue, 69 Inch)",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-B0HDLL6ZRS.webp?v=41176477975019833311793076264",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0HDLL6ZRS",
          "price": "$99.99",
          "priceMin": 99.99,
          "priceMax": 99.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "75 in",
            "81 in",
            "72 in",
            "78 in"
          ],
          "variants": [
            {
              "asin": "B0HDLL6ZRS",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDLL6ZRS",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HDL4SSBG",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDL4SSBG",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HDLD334D",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDLD334D",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HDL7382P",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDL7382P",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HDLDMZCH",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDLDMZCH",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        }
      ],
      "updatedAt": "2026-10-13",
      "gallery": [
        "https://m.media-amazon.com/images/I/71SSAxUwoOL._AC_SL1500_.jpg",
        "https://m.media-amazon.com/images/I/91lWrrZTNnL._AC_SL1500_.jpg",
        "https://m.media-amazon.com/images/I/91u1k1ekUqL._AC_SL1500_.jpg",
        "https://m.media-amazon.com/images/I/912LTDJ-koL._AC_SL1500_.jpg",
        "https://m.media-amazon.com/images/I/813zQCii9aL._AC_SL1500_.jpg",
        "https://m.media-amazon.com/images/I/910qUIfg4qL._AC_SL1500_.jpg"
      ],
      "aplus": [],
      "amazonTitle": "1680Denier 3000mm/3000mvp Super Waterproof & Breathable Horse Blankets for Winter with 250g Fill"
    },
    {
      "family": "muzzle",
      "section": "grazing-muzzles",
      "index": "02.1",
      "title": "Grazing Muzzles",
      "detail": "Easy-breathe / adjustable grazing control",
      "parents": [
        "B0FZWLDF6R"
      ],
      "items": [
        {
          "id": "muzzle-B0FZWLDF6R-01",
          "parent": "B0FZWLDF6R",
          "asin": "B0D7VSF5H7",
          "legacyAsins": [
            "B0D7VSF5H7",
            "B0D7VTPMLD",
            "B0D7VVD6Y6",
            "B0D7VTS552"
          ],
          "slug": "grazing-muzzles-black",
          "legacySlugs": [],
          "color": "Black",
          "productName": "Grazing Muzzles",
          "amazonTitle": "Horse Grazing Muzzle for Easy Breathe, Comfortable Muzzle Grazing for Horses with Adjustable Straps, Buckles, Suitable for Precaution of Laminitis",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-muzzle-B0FZWLDF6R-01-B0D7VSF5H7.jpg?v=26408015513935474511793076274",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0D7VSF5H7",
          "price": "$36.99",
          "priceMin": 36.99,
          "priceMax": 36.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Large",
            "Medium",
            "Small",
            "XLarge"
          ],
          "variants": [
            {
              "asin": "B0D7VSF5H7",
              "size": "Large",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0D7VSF5H7",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0D7VTPMLD",
              "size": "Medium",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0D7VTPMLD",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0D7VVD6Y6",
              "size": "Small",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0D7VVD6Y6",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0D7VTS552",
              "size": "XLarge",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0D7VTS552",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "muzzle-B0FZWLDF6R-07",
          "parent": "B0FZWLDF6R",
          "asin": "B0FP9PTJBG",
          "legacyAsins": [
            "B0FP9PTJBG",
            "B0FP9N69GT",
            "B0FP9Q1NCP",
            "B0FP9PPLZQ"
          ],
          "slug": "grazing-muzzles-red",
          "legacySlugs": [],
          "color": "Red",
          "productName": "Grazing Muzzles",
          "amazonTitle": "Horse Grazing Muzzle for Easy Breathe, Comfortable Muzzle Grazing for Horses with Adjustable Straps, Buckles, Suitable for Precaution of Laminitis",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-muzzle-B0FZWLDF6R-07-B0FP9PTJBG.jpg?v=72398549221193450191793076276",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0FP9N69GT",
          "price": "$36.99",
          "priceMin": 36.99,
          "priceMax": 36.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Large",
            "Medium",
            "Small",
            "XLarge"
          ],
          "variants": [
            {
              "asin": "B0FP9N69GT",
              "size": "Large",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FP9N69GT",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FP9Q1NCP",
              "size": "Medium",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FP9Q1NCP",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FP9PTJBG",
              "size": "Small",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FP9PTJBG",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FP9PPLZQ",
              "size": "XLarge",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FP9PPLZQ",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "muzzle-B0FZWLDF6R-04",
          "parent": "B0FZWLDF6R",
          "asin": "B0FP9P5B5N",
          "legacyAsins": [
            "B0FP9P5B5N",
            "B0FP9N4KHW",
            "B0FP9MB1M6",
            "B0FP9QJWZB"
          ],
          "slug": "grazing-muzzles-brown",
          "legacySlugs": [],
          "color": "Brown",
          "productName": "Grazing Muzzles",
          "amazonTitle": "Horse Grazing Muzzle for Easy Breathe, Comfortable Muzzle Grazing for Horses with Adjustable Straps, Buckles, Suitable for Precaution of Laminitis",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-muzzle-B0FZWLDF6R-04-B0FP9P5B5N.jpg?v=152581766930407630771793076275",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0FP9N4KHW",
          "price": "$36.99",
          "priceMin": 36.99,
          "priceMax": 36.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Large",
            "Medium",
            "Small",
            "XLarge"
          ],
          "variants": [
            {
              "asin": "B0FP9N4KHW",
              "size": "Large",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FP9N4KHW",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FP9MB1M6",
              "size": "Medium",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FP9MB1M6",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FP9P5B5N",
              "size": "Small",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FP9P5B5N",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FP9QJWZB",
              "size": "XLarge",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FP9QJWZB",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "muzzle-B0FZWLDF6R-05",
          "parent": "B0FZWLDF6R",
          "asin": "B0FP9QQPZD",
          "legacyAsins": [
            "B0FP9QQPZD",
            "B0FP9NNHNW",
            "B0FP9P95Z9",
            "B0FP9P6K4C"
          ],
          "slug": "grazing-muzzles-black-01",
          "legacySlugs": [],
          "color": "Black 01",
          "productName": "Grazing Muzzles",
          "amazonTitle": "Horse Grazing Muzzle for Easy Breathe, Comfortable Muzzle Grazing for Horses with Adjustable Straps, Buckles, Suitable for Precaution of Laminitis",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-muzzle-B0FZWLDF6R-05-B0FP9QQPZD.jpg?v=8351270739769149581793076275",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0FP9QQPZD",
          "price": "$36.99",
          "priceMin": 36.99,
          "priceMax": 36.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Large",
            "Small",
            "XLarge",
            "Medium"
          ],
          "variants": [
            {
              "asin": "B0FP9QQPZD",
              "size": "Large",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FP9QQPZD",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FP9NNHNW",
              "size": "Small",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FP9NNHNW",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FP9P95Z9",
              "size": "XLarge",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FP9P95Z9",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FP9P6K4C",
              "size": "Medium",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FP9P6K4C",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "muzzle-B0FZWLDF6R-02",
          "parent": "B0FZWLDF6R",
          "asin": "B0FP9N9D5B",
          "legacyAsins": [
            "B0FP9N9D5B",
            "B0FP9MWWBF",
            "B0FP9NJ3HZ",
            "B0FP9PDPJ9"
          ],
          "slug": "grazing-muzzles-orange",
          "legacySlugs": [],
          "color": "Orange",
          "productName": "Grazing Muzzles",
          "amazonTitle": "Horse Grazing Muzzle for Easy Breathe, Comfortable Muzzle Grazing for Horses with Adjustable Straps, Buckles, Suitable for Precaution of Laminitis",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-muzzle-B0FZWLDF6R-02-B0FP9N9D5B.jpg?v=179690824981002009571793076274",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0FP9MWWBF",
          "price": "$36.99",
          "priceMin": 36.99,
          "priceMax": 36.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Medium",
            "Small",
            "XLarge",
            "Large"
          ],
          "variants": [
            {
              "asin": "B0FP9MWWBF",
              "size": "Medium",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FP9MWWBF",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FP9N9D5B",
              "size": "Small",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FP9N9D5B",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FP9NJ3HZ",
              "size": "XLarge",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FP9NJ3HZ",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FP9PDPJ9",
              "size": "Large",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FP9PDPJ9",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "muzzle-B0FZWLDF6R-03",
          "parent": "B0FZWLDF6R",
          "asin": "B0FP9NQH9J",
          "legacyAsins": [
            "B0FP9NQH9J",
            "B0FP9RTBL6",
            "B0FP9QVSCF",
            "B0FP9NP6GN"
          ],
          "slug": "grazing-muzzles-blue",
          "legacySlugs": [],
          "color": "Blue",
          "productName": "Grazing Muzzles",
          "amazonTitle": "Horse Grazing Muzzle for Easy Breathe, Comfortable Muzzle Grazing for Horses with Adjustable Straps, Buckles, Suitable for Precaution of Laminitis",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-muzzle-B0FZWLDF6R-03-B0FP9NQH9J.jpg?v=183195730109981432981793076274",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0FP9NQH9J",
          "price": "$36.99",
          "priceMin": 36.99,
          "priceMax": 36.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Medium",
            "Small",
            "XLarge",
            "Large"
          ],
          "variants": [
            {
              "asin": "B0FP9NQH9J",
              "size": "Medium",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FP9NQH9J",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FP9RTBL6",
              "size": "Small",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FP9RTBL6",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FP9QVSCF",
              "size": "XLarge",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FP9QVSCF",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FP9NP6GN",
              "size": "Large",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FP9NP6GN",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "muzzle-B0FZWLDF6R-06",
          "parent": "B0FZWLDF6R",
          "asin": "B0FG7QV1W3",
          "legacyAsins": [
            "B0FG7QV1W3",
            "B0FG7668ZV",
            "B0FG77BDCC",
            "B0FG6QLJQ8"
          ],
          "slug": "grazing-muzzles-grey",
          "legacySlugs": [],
          "color": "Grey",
          "productName": "Grazing Muzzles",
          "amazonTitle": "Horse Grazing Muzzle for Easy Breathe, Comfortable Muzzle Grazing for Horses with Adjustable Straps, Buckles, Suitable for Precaution of Laminitis",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-muzzle-B0FZWLDF6R-06-B0FG7QV1W3.jpg?v=174371572501610814311793076275",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0FG7668ZV",
          "price": "$36.99",
          "priceMin": 36.99,
          "priceMax": 36.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Small",
            "XLarge",
            "Large",
            "Medium"
          ],
          "variants": [
            {
              "asin": "B0FG7668ZV",
              "size": "Small",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FG7668ZV",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FG7QV1W3",
              "size": "XLarge",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FG7QV1W3",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FG77BDCC",
              "size": "Large",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FG77BDCC",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0FG6QLJQ8",
              "size": "Medium",
              "sizeUnconfirmed": false,
              "price": 36.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FG6QLJQ8",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "muzzle-grazing-muzzles-black02",
          "parent": "B0FZWLDF6R",
          "asin": "B0H9HZ37B1",
          "legacyAsins": [
            "B0H9HZ37B1"
          ],
          "slug": "grazing-muzzles-black02",
          "legacySlugs": [],
          "color": "Black02",
          "productName": "Grazing Muzzles",
          "amazonTitle": "Horse Grazing Muzzle, Adjustable Noseband, Black Large",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-B0H9HZ37B1.webp?v=136869817745471057091793076262",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0H9HZ37B1",
          "price": "$39.99",
          "priceMin": 39.99,
          "priceMax": 39.99,
          "priceNote": "Amazon listing price",
          "availability": "check_availability",
          "status": "Confirm availability on Amazon",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Large"
          ],
          "variants": [
            {
              "asin": "B0H9HZ37B1",
              "size": "Large",
              "sizeUnconfirmed": false,
              "price": 39.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H9HZ37B1",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        }
      ],
      "updatedAt": "2026-10-13",
      "amazonTitle": "Horse Grazing Muzzle for Easy Breathe, Comfortable Muzzle Grazing for Horses with Adjustable Straps, Buckles, Suitable for Precaution of Laminitis"
    },
    {
      "family": "flyMask",
      "section": "fly-masks",
      "index": "03.1",
      "title": "Fly Masks",
      "detail": "Mesh eye and ear protection",
      "parents": [
        "B0GHZHXYKG",
        "B0GHT2JSVJ",
        "B0GX5DF8K5",
        "B0GX53W4H8",
        "B0HMNVXFRT",
        "B0HMP35RTV"
      ],
      "items": [
        {
          "id": "flyMask-B0GHZHXYKG-01",
          "parent": "B0GHT2JSVJ",
          "asin": "B0GHT2JSVJ",
          "legacyAsins": [
            "B0GHT2JSVJ",
            "B0GHSTM79X",
            "B0GHSTD5SB"
          ],
          "slug": "fine-mesh-fly-mask-gold",
          "legacySlugs": [],
          "color": "Gold",
          "productName": "Fine Mesh Fly Mask",
          "amazonTitle": "Breathable Horse Fly Mask Tear-Resistant Mesh Fly Masks for Horses with Soft Fleece Edges & Adjustable Touch Straps Equine Mask with Ears",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-flyMask-B0GHZHXYKG-01-B0GHT2JSVJ.jpg?v=78280825882217414381793076266",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0GHT2JSVJ",
          "price": "$19.99",
          "priceMin": 19.99,
          "priceMax": 19.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Option 1 — confirm size on Amazon",
            "Option 2 — confirm size on Amazon",
            "Medium"
          ],
          "variants": [
            {
              "asin": "B0GHT2JSVJ",
              "size": "Option 1 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 19.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHT2JSVJ",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHSTM79X",
              "size": "Option 2 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 19.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHSTM79X",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHSTD5SB",
              "size": "Medium",
              "sizeUnconfirmed": false,
              "price": 19.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHSTD5SB",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "flyMask-B0GHZHXYKG-05",
          "parent": "B0GX5DF8K5",
          "asin": "B0GX5DF8K5",
          "legacyAsins": [
            "B0GX5DF8K5",
            "B0GX4W6CCC",
            "B0GX515PPG"
          ],
          "slug": "fine-mesh-fly-mask-soccer-print",
          "legacySlugs": [],
          "color": "Soccer Print",
          "productName": "Fine Mesh Fly Mask",
          "amazonTitle": "Fine Mesh Horse Fly Mask with Ears Lightweight UV Protection Fly Mask for Horses Large 3D Eye Space with Soft Fleece Trim Adjustable Straps",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-flyMask-B0GHZHXYKG-05-B0GX5DF8K5.jpg?v=157153945253567072501793076267",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0GX5DF8K5",
          "price": "$16.99",
          "priceMin": 16.99,
          "priceMax": 16.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Option 1 — confirm size on Amazon",
            "Meduim",
            "Small"
          ],
          "variants": [
            {
              "asin": "B0GX5DF8K5",
              "size": "Option 1 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 16.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GX5DF8K5",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GX4W6CCC",
              "size": "Meduim",
              "sizeUnconfirmed": false,
              "price": 16.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GX4W6CCC",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GX515PPG",
              "size": "Small",
              "sizeUnconfirmed": false,
              "price": 16.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GX515PPG",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "flyMask-B0GHZHXYKG-04",
          "parent": "B0HMNVXFRT",
          "asin": "B0GHSRGFVK",
          "legacyAsins": [
            "B0GHSRGFVK",
            "B0GHSJY7Q3",
            "B0GHSNM66Z"
          ],
          "slug": "fine-mesh-fly-mask-silver",
          "legacySlugs": [],
          "color": "Silver",
          "productName": "Fine Mesh Fly Mask",
          "amazonTitle": "Breathable Horse Fly Mask Tear-Resistant Mesh Fly Masks for Horses with Soft Fleece Edges & Adjustable Touch Straps Equine Mask with Ears",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-flyMask-B0GHZHXYKG-04-B0GHSRGFVK.jpg?v=66395480316294822231793076267",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0GHSJY7Q3",
          "price": "$19.99",
          "priceMin": 19.99,
          "priceMax": 19.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Large",
            "Medium",
            "Small"
          ],
          "variants": [
            {
              "asin": "B0GHSJY7Q3",
              "size": "Large",
              "sizeUnconfirmed": false,
              "price": 19.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHSJY7Q3",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHSRGFVK",
              "size": "Medium",
              "sizeUnconfirmed": false,
              "price": 19.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHSRGFVK",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GHSNM66Z",
              "size": "Small",
              "sizeUnconfirmed": false,
              "price": 19.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GHSNM66Z",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "flyMask-fly-masks-sand-navy",
          "parent": "B0HMNVXFRT",
          "asin": "B0H9HQ268C",
          "legacyAsins": [
            "B0H9HQ268C",
            "B0H9HNLTHC",
            "B0H9HQ848Z"
          ],
          "slug": "fly-masks-sand-navy",
          "legacySlugs": [],
          "color": "Sand-Navy",
          "productName": "Fly Masks",
          "amazonTitle": "Fine Mesh Horse Fly Mask with Ears Lightweight UV Protection Fly Mask for Horses Large 3D Eye Space with Soft Fleece Trim Adjustable Straps",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-B0H9HQ268C.webp?v=170130163301752385851793076262",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0H9HQ268C",
          "price": "$25.99",
          "priceMin": 25.99,
          "priceMax": 25.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Large",
            "Medium",
            "Small"
          ],
          "variants": [
            {
              "asin": "B0H9HQ268C",
              "size": "Large",
              "sizeUnconfirmed": false,
              "price": 25.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H9HQ268C",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H9HNLTHC",
              "size": "Medium",
              "sizeUnconfirmed": false,
              "price": 25.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H9HNLTHC",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H9HQ848Z",
              "size": "Small",
              "sizeUnconfirmed": false,
              "price": 25.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H9HQ848Z",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "flyMask-B0GHZHXYKG-02",
          "parent": "B0GX53W4H8",
          "asin": "B0GX53W4H8",
          "legacyAsins": [
            "B0GX53W4H8",
            "B0GX5D3RQX",
            "B0GX54S2BJ"
          ],
          "slug": "fine-mesh-fly-mask-burgundy-star-print",
          "legacySlugs": [],
          "color": "Burgundy Star Print",
          "productName": "Fine Mesh Fly Mask",
          "amazonTitle": "Fine Mesh Horse Fly Mask with Ears Lightweight UV Protection Fly Mask for Horses Large 3D Eye Space with Soft Fleece Trim Adjustable Straps",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-flyMask-B0GHZHXYKG-02-B0GX53W4H8.jpg?v=112881879987394411501793076266",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0GX5D3RQX",
          "price": "$16.99",
          "priceMin": 16.99,
          "priceMax": 16.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Option 1 — confirm size on Amazon",
            "Option 2 — confirm size on Amazon",
            "Small"
          ],
          "variants": [
            {
              "asin": "B0GX5D3RQX",
              "size": "Option 1 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 16.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GX5D3RQX",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GX53W4H8",
              "size": "Option 2 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 16.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GX53W4H8",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GX54S2BJ",
              "size": "Small",
              "sizeUnconfirmed": false,
              "price": 16.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GX54S2BJ",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "flyMask-B0GHZHXYKG-03",
          "parent": "B0HMP35RTV",
          "asin": "B0GX532WGL",
          "legacyAsins": [
            "B0GX56NZK7",
            "B0GX532WGL",
            "B0GX4YCK98"
          ],
          "slug": "fine-mesh-fly-mask-blue-star-print",
          "legacySlugs": [],
          "color": "Blue Star Print",
          "productName": "Fine Mesh Fly Mask",
          "amazonTitle": "Fine Mesh Horse Fly Mask with Ears Lightweight UV Protection Fly Mask for Horses Large 3D Eye Space with Soft Fleece Trim Adjustable Straps",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-flyMask-B0GHZHXYKG-03-B0GX56NZK7.jpg?v=156937583180142129761793076267",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0GX532WGL",
          "price": "$16.99",
          "priceMin": 16.99,
          "priceMax": 16.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Large",
            "Small",
            "Meduim"
          ],
          "variants": [
            {
              "asin": "B0GX532WGL",
              "size": "Large",
              "sizeUnconfirmed": false,
              "price": 16.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GX532WGL",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GX4YCK98",
              "size": "Small",
              "sizeUnconfirmed": false,
              "price": 16.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GX4YCK98",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GX56NZK7",
              "size": "Meduim",
              "sizeUnconfirmed": false,
              "price": 16.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GX56NZK7",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        }
      ],
      "updatedAt": "2026-10-13",
      "amazonTitle": "Breathable Horse Fly Mask Tear-Resistant Mesh Fly Masks for Horses with Soft Fleece Edges & Adjustable Touch Straps Equine Mask with Ears"
    },
    {
      "family": "girth",
      "section": "girth-protection",
      "index": "04.1",
      "title": "Western Girths",
      "detail": "Double roller buckle / terry lining",
      "parents": [
        "B0GTKBGGGJ"
      ],
      "items": [
        {
          "id": "girth-B0GTKBGGGJ-02",
          "parent": "B0GTKBGGGJ",
          "asin": "B0GTKC119X",
          "legacyAsins": [
            "B0GTKC119X",
            "B0GTKCGWWN",
            "B0GTK7R4GW",
            "B0GTKBYMN9",
            "B0GTKDFM9M"
          ],
          "slug": "western-girths-black",
          "legacySlugs": [],
          "color": "Black",
          "productName": "Western Girths",
          "amazonTitle": "Western Horse Cinch with Stainless Steel Double Roller Buckles, Anti-Slip Terry Lining, Comfortable Western Saddle Girth for Stable Saddle Fit, Trail Riding and Ranch Work",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-girth-B0GTKBGGGJ-02-B0GTKC119X.jpg?v=81400884075290983681793076268",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0GTKCGWWN",
          "price": "$49.99",
          "priceMin": 49.99,
          "priceMax": 49.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "24\"",
            "27\"",
            "33\"",
            "36\"",
            "30\""
          ],
          "variants": [
            {
              "asin": "B0GTKCGWWN",
              "size": "24\"",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GTKCGWWN",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GTK7R4GW",
              "size": "27\"",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GTK7R4GW",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GTKC119X",
              "size": "33\"",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GTKC119X",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GTKBYMN9",
              "size": "36\"",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GTKBYMN9",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GTKDFM9M",
              "size": "30\"",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GTKDFM9M",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "girth-B0GTKBGGGJ-01",
          "parent": "B0GTKBGGGJ",
          "asin": "B0GTKC684R",
          "legacyAsins": [
            "B0GTKC684R",
            "B0GTKF953S",
            "B0GTKC37MT",
            "B0GTKPWQC8",
            "B0GTKDNF4G"
          ],
          "slug": "western-girths-brown",
          "legacySlugs": [],
          "color": "Brown",
          "productName": "Western Girths",
          "amazonTitle": "Western Horse Cinch with Stainless Steel Double Roller Buckles, Anti-Slip Terry Lining, Comfortable Western Saddle Girth for Stable Saddle Fit, Trail Riding and Ranch Work",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-girth-B0GTKBGGGJ-01-B0GTKC684R.jpg?v=117117494027269601521793076268",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0GTKC684R",
          "price": "$49.99",
          "priceMin": 49.99,
          "priceMax": 49.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "24\"",
            "27\"",
            "33\"",
            "30\"",
            "36\""
          ],
          "variants": [
            {
              "asin": "B0GTKC684R",
              "size": "24\"",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GTKC684R",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GTKF953S",
              "size": "27\"",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GTKF953S",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GTKC37MT",
              "size": "33\"",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GTKC37MT",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GTKPWQC8",
              "size": "30\"",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GTKPWQC8",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0GTKDNF4G",
              "size": "36\"",
              "sizeUnconfirmed": false,
              "price": 49.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GTKDNF4G",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        }
      ],
      "updatedAt": "2026-10-13",
      "amazonTitle": "Western Horse Cinch with Stainless Steel Double Roller Buckles, Anti-Slip Terry Lining, Comfortable Western Saddle Girth for Stable Saddle Fit, Trail Riding and Ranch Work"
    },
    {
      "family": "spurs",
      "section": "saddle-tack",
      "index": "05.1",
      "title": "Training Spurs",
      "detail": "Flat-end riding cues / adjustable straps",
      "parents": [
        "B0GJTXHFMZ"
      ],
      "items": [
        {
          "id": "spurs-B0GJTXHFMZ-03",
          "parent": "B0GJTXHFMZ",
          "asin": "B0GJTQJMSV",
          "legacyAsins": [
            "B0GJTQJMSV"
          ],
          "slug": "training-spurs-size-1-3-16-neck",
          "legacySlugs": [],
          "color": "Size 1 3/16\" Neck",
          "productName": "Training Spurs",
          "amazonTitle": "Horse Spurs with Adjustable Nylon Straps, Rust-Resistant Nickel-Plated Zinc Alloy, Humane Flat-End Design for Gentle Riding Cues, English Equestrian Training Spurs 1 3/16\" Neck",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-spurs-B0GJTXHFMZ-03-B0GJTQJMSV.jpg?v=122781059573616087651793076281",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0GJTQJMSV",
          "price": null,
          "priceMin": null,
          "priceMax": null,
          "priceNote": "Check price on Amazon",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "1 3/16\" Neck"
          ],
          "variants": [
            {
              "asin": "B0GJTQJMSV",
              "size": "1 3/16\" Neck",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0GJTQJMSV",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "spurs-B0GJTXHFMZ-02",
          "parent": "B0GJTXHFMZ",
          "asin": "B0H2B9S8KL",
          "legacyAsins": [
            "B0H2B9S8KL",
            "B0H2ZZH9BJ"
          ],
          "slug": "training-spurs-size-3-4-neck",
          "legacySlugs": [],
          "color": "Size 3/4“ Neck",
          "productName": "Training Spurs",
          "amazonTitle": "Horse Spurs with Adjustable Nylon Straps, Rust-Resistant Nickel-Plated Zinc Alloy, Humane Flat-End Design for Gentle Riding Cues, English Equestrian Training Spurs (3/4“ Neck)",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-spurs-B0GJTXHFMZ-02-B0H2B9S8KL.jpg?v=44123702172067189331793076281",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0H2B9S8KL",
          "price": "$21.99",
          "priceMin": 21.99,
          "priceMax": 21.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "3/4“ Neck",
            "7/8\""
          ],
          "variants": [
            {
              "asin": "B0H2B9S8KL",
              "size": "3/4“ Neck",
              "sizeUnconfirmed": false,
              "price": 21.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0H2B9S8KL",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0H2ZZH9BJ",
              "size": "7/8\"",
              "sizeUnconfirmed": false,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0H2ZZH9BJ",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "spurs-B0GJTXHFMZ-01",
          "parent": "B0GJTXHFMZ",
          "asin": "B0FPB2W3VD",
          "legacyAsins": [
            "B0FPB2W3VD"
          ],
          "slug": "training-spurs-size-1-neck",
          "legacySlugs": [],
          "color": "Size 1\" Neck",
          "productName": "Training Spurs",
          "amazonTitle": "Horse Spurs with Adjustable Nylon Straps, Rust-Resistant Nickel-Plated Zinc Alloy, Humane Flat-End Design for Gentle Riding Cues, English Equestrian Training Spurs 1\" Neck",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-spurs-B0GJTXHFMZ-01-B0FPB2W3VD.jpg?v=105584439271513576861793076280",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0FPB2W3VD",
          "price": "$21.99",
          "priceMin": 21.99,
          "priceMax": 21.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "1\" Neck"
          ],
          "variants": [
            {
              "asin": "B0FPB2W3VD",
              "size": "1\" Neck",
              "sizeUnconfirmed": false,
              "price": 21.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FPB2W3VD",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        }
      ],
      "updatedAt": "2026-10-13",
      "amazonTitle": "Horse Spurs with Adjustable Nylon Straps, Rust-Resistant Nickel-Plated Zinc Alloy, Humane Flat-End Design for Gentle Riding Cues, English Equestrian Training Spurs 1 3/16\" Neck"
    },
    {
      "family": "bits",
      "section": "saddle-tack",
      "index": "05.2",
      "title": "Snaffle Bits",
      "detail": "Durable H-ring horse bits",
      "parents": [
        "B0FJTCTPY7"
      ],
      "items": [
        {
          "id": "bits-B0FJTCTPY7-02",
          "parent": "B0FJTCTPY7",
          "asin": "B0FGJJ37K3",
          "legacyAsins": [
            "B0FGJJ37K3"
          ],
          "slug": "snaffle-bits-style-2",
          "legacySlugs": [
            "snaffle-bits-sku-mt110n-45"
          ],
          "color": "Style 2",
          "productName": "Snaffle Bits",
          "amazonTitle": "Mouth Gag Bit Durable Horse Snaffle Bit",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-bits-B0FJTCTPY7-02-B0FGJJ37K3.jpg?v=22638208511187479681793076265",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0FGJJ37K3",
          "price": null,
          "priceMin": null,
          "priceMax": null,
          "priceNote": "Check price on Amazon",
          "availability": "unavailable",
          "status": "Not currently listed for sale",
          "updatedAt": "2026-10-13",
          "archived": true,
          "sizes": [
            "Option 1 — confirm size on Amazon"
          ],
          "variants": [
            {
              "asin": "B0FGJJ37K3",
              "size": "Option 1 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 9.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FGJJ37K3",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "bits-B0FJTCTPY7-01",
          "parent": "B0FJTCTPY7",
          "asin": "B0FGJFJCZ6",
          "legacyAsins": [
            "B0FGJFJCZ6"
          ],
          "slug": "snaffle-bits-style-1",
          "legacySlugs": [
            "snaffle-bits-sku-mth115n-45"
          ],
          "color": "Style 1",
          "productName": "Snaffle Bits",
          "amazonTitle": "Horse Snaffle Bit Durable H-Ring Bit for Horses",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-bits-B0FJTCTPY7-01-B0FGJFJCZ6.jpg?v=22638208511187479681793076264",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0FGJFJCZ6",
          "price": null,
          "priceMin": null,
          "priceMax": null,
          "priceNote": "Check price on Amazon",
          "availability": "unavailable",
          "status": "Not currently listed for sale",
          "updatedAt": "2026-10-13",
          "archived": true,
          "sizes": [
            "Option 1 — confirm size on Amazon"
          ],
          "variants": [
            {
              "asin": "B0FGJFJCZ6",
              "size": "Option 1 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 9.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0FGJFJCZ6",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        }
      ],
      "updatedAt": "2026-10-13",
      "amazonTitle": "Mouth Gag Bit Durable Horse Snaffle Bit"
    },
    {
      "family": "groomingTote",
      "section": "stable-grooming",
      "index": "06.1",
      "title": "600D Grooming Totes",
      "detail": "Waterproof / 7-pocket storage",
      "parents": [
        "B0DHFQ4G3W"
      ],
      "items": [
        {
          "id": "groomingTote-B0DHFQ4G3W-04",
          "parent": "B0DHFQ4G3W",
          "asin": "B0DJ5KD97Z",
          "legacyAsins": [
            "B0DJ5KD97Z"
          ],
          "slug": "600d-grooming-totes-senior-grey-ancora-red",
          "legacySlugs": [],
          "color": "Senior grey/Ancora red",
          "productName": "600D Grooming Totes",
          "amazonTitle": "600Denier 3000mm/3000mvp Super Waterproof,Breathable Horse Grooming Tote Bag with 7 Pockets Tear-resistant Tack Storage Carry Bag Caddy Bag for Horse Cow Donkey Goats",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-groomingTote-B0DHFQ4G3W-04-B0DJ5KD97Z.jpg?v=43363838807141603961793076269",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0DJ5KD97Z",
          "price": null,
          "priceMin": null,
          "priceMax": null,
          "priceNote": "Check price on Amazon",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Option 1 — confirm size on Amazon"
          ],
          "variants": [
            {
              "asin": "B0DJ5KD97Z",
              "size": "Option 1 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0DJ5KD97Z",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "groomingTote-B0DHFQ4G3W-01",
          "parent": "B0DHFQ4G3W",
          "asin": "B0DHG3V583",
          "legacyAsins": [
            "B0DHG3V583"
          ],
          "slug": "600d-grooming-totes-navy-red",
          "legacySlugs": [],
          "color": "Navy/Red",
          "productName": "600D Grooming Totes",
          "amazonTitle": "600Denier 3000mm/3000mvp Super Waterproof, Breathable Horse Grooming Tote with 7 Pockets - Tear-resistant Tack Storage Carry Caddy Bag for Horses, Cows, Donkeys, Goats",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-groomingTote-B0DHFQ4G3W-01-B0DHG3V583.jpg?v=82339941500763051731793076268",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0DHG3V583",
          "price": null,
          "priceMin": null,
          "priceMax": null,
          "priceNote": "Check price on Amazon",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Option 1 — confirm size on Amazon"
          ],
          "variants": [
            {
              "asin": "B0DHG3V583",
              "size": "Option 1 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0DHG3V583",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "groomingTote-B0DHFQ4G3W-03",
          "parent": "B0DHFQ4G3W",
          "asin": "B0DHFXJRTQ",
          "legacyAsins": [
            "B0DHFXJRTQ"
          ],
          "slug": "600d-grooming-totes-red",
          "legacySlugs": [],
          "color": "Red",
          "productName": "600D Grooming Totes",
          "amazonTitle": "600Denier 3000mm/3000mvp Super Waterproof, Breathable Horse Grooming Tote with 7 Pockets - Tear-Resistant Tack Storage Carry Bag Caddy for Horses, Cows, Donkeys, Goats",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-groomingTote-B0DHFQ4G3W-03-B0DHFXJRTQ.jpg?v=23495178722709258651793076269",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0DHFXJRTQ",
          "price": null,
          "priceMin": null,
          "priceMax": null,
          "priceNote": "Check price on Amazon",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Option 1 — confirm size on Amazon"
          ],
          "variants": [
            {
              "asin": "B0DHFXJRTQ",
              "size": "Option 1 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0DHFXJRTQ",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "groomingTote-B0DHFQ4G3W-02",
          "parent": "B0DHFQ4G3W",
          "asin": "B0DJ5LDF3C",
          "legacyAsins": [
            "B0DJ5LDF3C"
          ],
          "slug": "600d-grooming-totes-ancora-red",
          "legacySlugs": [],
          "color": "Ancora red",
          "productName": "600D Grooming Totes",
          "amazonTitle": "600Denier 3000mm/3000mvp Super Waterproof, Breathable Horse Grooming Tote with 7 Pockets, Tear-resistant Tack Storage, Carry Bag Caddy for Horse, Cow, Donkey, Goats, Dog",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-groomingTote-B0DHFQ4G3W-02-B0DJ5LDF3C.jpg?v=18248838728771333901793076269",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0DJ5LDF3C",
          "price": null,
          "priceMin": null,
          "priceMax": null,
          "priceNote": "Check price on Amazon",
          "availability": "unavailable",
          "status": "Not currently listed for sale",
          "updatedAt": "2026-10-13",
          "archived": true,
          "sizes": [
            "Option 1 — confirm size on Amazon"
          ],
          "variants": [
            {
              "asin": "B0DJ5LDF3C",
              "size": "Option 1 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0DJ5LDF3C",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        }
      ],
      "updatedAt": "2026-10-13",
      "amazonTitle": "600Denier 3000mm/3000mvp Super Waterproof,Breathable Horse Grooming Tote Bag with 7 Pockets Tear-resistant Tack Storage Carry Bag Caddy Bag for Horse Cow Donkey Goats"
    },
    {
      "family": "meshGrooming",
      "section": "stable-grooming",
      "index": "06.2",
      "title": "Mesh Grooming Bags",
      "detail": "Breathable / waterproof 8-pocket organizer",
      "parents": [
        "B0D7VW918S"
      ],
      "items": [
        {
          "id": "meshGrooming-B0D7VW918S-03",
          "parent": "B0D7VW918S",
          "asin": "B0DDPNBM2T",
          "legacyAsins": [
            "B0DDPNBM2T"
          ],
          "slug": "mesh-grooming-bags-silver",
          "legacySlugs": [],
          "color": "Silver",
          "productName": "Mesh Grooming Bags",
          "amazonTitle": "Breathable & Waterproof Mesh Horse Grooming Bag with 8 Pockets Tear-Resistant Grooming Tote for Horse Grooming Caddy Bag Organizer to Secure Items(Silver)",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-meshGrooming-B0D7VW918S-03-B0DDPNBM2T.jpg?v=155963128247656963751793076273",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0DDPNBM2T",
          "price": null,
          "priceMin": null,
          "priceMax": null,
          "priceNote": "Check price on Amazon",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Option 1 — confirm size on Amazon"
          ],
          "variants": [
            {
              "asin": "B0DDPNBM2T",
              "size": "Option 1 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0DDPNBM2T",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "meshGrooming-B0D7VW918S-01",
          "parent": "B0D7VW918S",
          "asin": "B0D7WHBG35",
          "legacyAsins": [
            "B0D7WHBG35"
          ],
          "slug": "mesh-grooming-bags-blue",
          "legacySlugs": [],
          "color": "Blue",
          "productName": "Mesh Grooming Bags",
          "amazonTitle": "Breathable & Waterproof Mesh Horse Grooming Bag with 8 Pockets Tear-Resistant Grooming Tote for Horse Grooming Caddy Bag Organizer to Secure Items (Blue)",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-meshGrooming-B0D7VW918S-01-B0D7WHBG35.jpg?v=3908371779376388801793076273",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0D7WHBG35",
          "price": "$17.99",
          "priceMin": 17.99,
          "priceMax": 17.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Option 1 — confirm size on Amazon"
          ],
          "variants": [
            {
              "asin": "B0D7WHBG35",
              "size": "Option 1 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 17.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0D7WHBG35",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        },
        {
          "id": "meshGrooming-B0D7VW918S-02",
          "parent": "B0D7VW918S",
          "asin": "B0DDPQZTTW",
          "legacyAsins": [
            "B0DDPQZTTW"
          ],
          "slug": "mesh-grooming-bags-sand",
          "legacySlugs": [],
          "color": "Sand",
          "productName": "Mesh Grooming Bags",
          "amazonTitle": "Breathable & Waterproof Mesh Horse Grooming Bag with 8 Pockets Tear-Resistant Grooming Tote for Horse Grooming Caddy Bag Organizer to Secure Items (Sand)",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-meshGrooming-B0D7VW918S-02-B0DDPQZTTW.jpg?v=63194856421234985701793076273",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0DDPQZTTW",
          "price": null,
          "priceMin": null,
          "priceMax": null,
          "priceNote": "Check price on Amazon",
          "availability": "unavailable",
          "status": "Not currently listed for sale",
          "updatedAt": "2026-10-13",
          "archived": true,
          "sizes": [
            "Option 1 — confirm size on Amazon"
          ],
          "variants": [
            {
              "asin": "B0DDPQZTTW",
              "size": "Option 1 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": null,
              "priceSource": "not_returned",
              "amazon": "https://www.amazon.com/dp/B0DDPQZTTW",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        }
      ],
      "updatedAt": "2026-10-13",
      "amazonTitle": "Breathable & Waterproof Mesh Horse Grooming Bag with 8 Pockets Tear-Resistant Grooming Tote for Horse Grooming Caddy Bag Organizer to Secure Items(Silver)"
    },
    {
      "family": "hayBag",
      "section": "stable-grooming",
      "index": "06.3",
      "title": "Slow Feed Hay Bags",
      "detail": "Large trailer feeder / metal snap",
      "parents": [
        "B0D7WFCWVZ"
      ],
      "items": [
        {
          "id": "hayBag-B0D7WFCWVZ-01",
          "parent": "B0D7WFCWVZ",
          "asin": "B0DDPC5F9V",
          "legacyAsins": [
            "B0DDPC5F9V"
          ],
          "slug": "slow-feed-hay-bags-yellow",
          "legacySlugs": [],
          "color": "Yellow",
          "productName": "Slow Feed Hay Bags",
          "amazonTitle": "Large Hay Bag for Horses - Slow Feed 27\" * 21\" * 6\" - Trailer Feeder for Cow, Goats, Donkey, Cattle - Open Feed Hole and Metal Snap Fastener",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-hayBag-B0D7WFCWVZ-01-B0DDPC5F9V.jpg?v=91466078495267392111793076269",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0DDPC5F9V",
          "price": "$15.99",
          "priceMin": 15.99,
          "priceMax": 15.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "Option 1 — confirm size on Amazon"
          ],
          "variants": [
            {
              "asin": "B0DDPC5F9V",
              "size": "Option 1 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 15.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0DDPC5F9V",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        }
      ],
      "updatedAt": "2026-10-13",
      "amazonTitle": "Large Hay Bag for Horses - Slow Feed 27\" * 21\" * 6\" - Trailer Feeder for Cow, Goats, Donkey, Cattle - Open Feed Hole and Metal Snap Fastener"
    },
    {
      "family": "dogCover",
      "section": "travel-seasonal",
      "index": "07.1",
      "title": "Back Seat Dog Cover",
      "detail": "Waterproof 4-in-1 travel hammock",
      "parents": [
        "B0GWD55S83"
      ],
      "items": [
        {
          "id": "dogCover-B0GWD55S83-01",
          "parent": "B0GWD55S83",
          "asin": "B0GWD55S83",
          "legacyAsins": [
            "B0GWD55S83"
          ],
          "slug": "back-seat-dog-cover-standard",
          "legacySlugs": [
            "back-seat-dog-cover-sku-cwd01-k"
          ],
          "color": "Standard",
          "productName": "Back Seat Dog Cover",
          "amazonTitle": "Waterproof Back Seat Dog Cover for Cars SUVs and Small Trucks, 4-in-1 Dog Hammock Backseat Extender with Anti-Slip Mesh Bottom, Side Flaps, Dual Pockets, Easy-Clean Textured Surface",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-full-dogCover-B0GWD55S83-01-B0GWD55S83.jpg?v=177223314158285002501793076266",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0GWD55S83",
          "price": null,
          "priceMin": null,
          "priceMax": null,
          "priceNote": "Check price on Amazon",
          "availability": "unavailable",
          "status": "Not currently listed for sale",
          "updatedAt": "2026-10-13",
          "archived": true,
          "sizes": [
            "Option 1 — confirm size on Amazon"
          ],
          "variants": [
            {
              "asin": "B0GWD55S83",
              "size": "Option 1 — confirm size on Amazon",
              "sizeUnconfirmed": true,
              "price": 35.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0GWD55S83",
              "availability": "unavailable",
              "status": "Not currently listed for sale",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": false
        }
      ],
      "updatedAt": "2026-10-13",
      "amazonTitle": "Waterproof Back Seat Dog Cover for Cars SUVs and Small Trucks, 4-in-1 Dog Hammock Backseat Extender with Anti-Slip Mesh Bottom, Side Flaps, Dual Pockets, Easy-Clean Textured Surface"
    },
    {
      "family": "winterStable300",
      "section": "horse-sheets",
      "index": "01.7",
      "title": "420D Winter Stable Blanket",
      "detail": "420D polyester outer / 300g insulating fill / stable use",
      "parents": [
        "B0HDLCLHFV"
      ],
      "items": [
        {
          "id": "winterStable300-420d-winter-stable-blanket-black",
          "parent": "B0HDLCLHFV",
          "asin": "B0HDLJZBF5",
          "legacyAsins": [
            "B0HDLJZBF5",
            "B0HDL72D9Z",
            "B0HDLFZ5GN",
            "B0HDL7NZ7L",
            "B0HDL92K3S"
          ],
          "slug": "420d-winter-stable-blanket-black",
          "legacySlugs": [],
          "color": "Black",
          "productName": "420D Winter Stable Blanket",
          "amazonTitle": "Winter Horse Stable Blanket, 300g Insulating Fill, 420D Polyester Outer, Fleece Wither Pad, Shoulder Gusset, Adjustable Buckles & Belly Strap for Cold Weather",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-B0HDLJZBF5.webp?v=8254630864350927031793076264",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0HDLJZBF5",
          "price": "$99.99",
          "priceMin": 99.99,
          "priceMax": 99.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "72 in",
            "78 in",
            "75 in",
            "81 in"
          ],
          "variants": [
            {
              "asin": "B0HDLJZBF5",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDLJZBF5",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HDL72D9Z",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDL72D9Z",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HDLFZ5GN",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDLFZ5GN",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HDL7NZ7L",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDL7NZ7L",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HDL92K3S",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDL92K3S",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": true
        },
        {
          "id": "winterStable300-420d-winter-stable-blanket-red",
          "parent": "B0HDLCLHFV",
          "asin": "B0HDLGPNSC",
          "legacyAsins": [
            "B0HDLGPNSC",
            "B0HDLP5GL6",
            "B0HDL9RQ1G",
            "B0HDLQ6XLS",
            "B0HDLBL7MW"
          ],
          "slug": "420d-winter-stable-blanket-red",
          "legacySlugs": [],
          "color": "Red",
          "productName": "420D Winter Stable Blanket",
          "amazonTitle": "Winter Horse Stable Blanket, 300g Insulating Fill, 420D Polyester Outer, Fleece Wither Pad, Shoulder Gusset, Adjustable Buckles & Belly Strap for Cold Weather",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-B0HDLGPNSC.webp?v=31177361210434126091793076263",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0HDLGPNSC",
          "price": "$99.99",
          "priceMin": 99.99,
          "priceMax": 99.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "75 in",
            "81 in",
            "72 in",
            "78 in"
          ],
          "variants": [
            {
              "asin": "B0HDLGPNSC",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDLGPNSC",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HDLP5GL6",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDLP5GL6",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HDL9RQ1G",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDL9RQ1G",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HDLQ6XLS",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDLQ6XLS",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HDLBL7MW",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDLBL7MW",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": true
        },
        {
          "id": "winterStable300-420d-winter-stable-blanket-blue",
          "parent": "B0HDLCLHFV",
          "asin": "B0HDLJQ7DJ",
          "legacyAsins": [
            "B0HDLJQ7DJ",
            "B0HDLJ7B7J",
            "B0HDLDYDZQ",
            "B0HDLDPFHN",
            "B0HDLCVB1J"
          ],
          "slug": "420d-winter-stable-blanket-blue",
          "legacySlugs": [],
          "color": "Blue",
          "productName": "420D Winter Stable Blanket",
          "amazonTitle": "Winter Horse Stable Blanket, 300g Insulating Fill, 420D Polyester Outer, Fleece Wither Pad, Shoulder Gusset, Adjustable Buckles & Belly Strap for Cold Weather",
          "image": "//barnandstable.us/cdn/shop/t/13/assets/lx-B0HDLJQ7DJ.webp?v=150211198351239278751793076263",
          "imageVerified": true,
          "amazon": "https://www.amazon.com/dp/B0HDLJQ7DJ",
          "price": "$99.99",
          "priceMin": 99.99,
          "priceMax": 99.99,
          "priceNote": "Amazon listing price",
          "availability": "in_stock",
          "status": "Available at last check",
          "updatedAt": "2026-10-13",
          "archived": false,
          "sizes": [
            "69 in",
            "75 in",
            "81 in",
            "72 in",
            "78 in"
          ],
          "variants": [
            {
              "asin": "B0HDLJQ7DJ",
              "size": "69 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDLJQ7DJ",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HDLJ7B7J",
              "size": "75 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDLJ7B7J",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HDLDYDZQ",
              "size": "81 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDLDYDZQ",
              "availability": "in_stock",
              "status": "Available at last check",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HDLDPFHN",
              "size": "72 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDLDPFHN",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            },
            {
              "asin": "B0HDLCVB1J",
              "size": "78 in",
              "sizeUnconfirmed": false,
              "price": 99.99,
              "priceSource": "lingxing_listing_price",
              "amazon": "https://www.amazon.com/dp/B0HDLCVB1J",
              "availability": "check_availability",
              "status": "Confirm availability on Amazon",
              "updatedAt": "2026-10-13"
            }
          ],
          "newArrival": true
        }
      ],
      "updatedAt": "2026-10-13",
      "gallery": [
        "https://m.media-amazon.com/images/I/71PbMwIOHcL.jpg",
        "https://m.media-amazon.com/images/I/81GJZiQ8sqL.jpg",
        "https://m.media-amazon.com/images/I/818SJfP7jSL.jpg",
        "https://m.media-amazon.com/images/I/81s-uh2GTfL.jpg",
        "https://m.media-amazon.com/images/I/910PVcFJkaL.jpg",
        "https://m.media-amazon.com/images/I/81Ufa0rQ-GL.jpg",
        "https://m.media-amazon.com/images/I/81iFMckBwDL.jpg",
        "https://m.media-amazon.com/images/I/81c8Bo2UT5L.jpg"
      ],
      "aplus": [],
      "amazonTitle": "Winter Horse Stable Blanket, 300g Insulating Fill, 420D Polyester Outer, Fleece Wither Pad, Shoulder Gusset, Adjustable Buckles & Belly Strap for Cold Weather"
    }
  ],
  "currency": "USD"
};
